import { useTheme } from 'styled-components';
import {
  BannerSection,
  CloseIconWrapper,
  LeftColumn,
  RightColumn,
  Title,
} from './styles';
import Button from '@components/Button';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { getEventDetails } from '@store/slices/eventSlice';
import { useMobileWidth } from '@utils/hooks';
import { useState } from 'react';
import Icon from '@components/Icon';

export const Banner = ({ bgImage }: { bgImage: string }) => {
  const theme = useTheme();
  const { t } = useTranslation();
  const sluggedEvent = useSelector(getEventDetails)?.[0];
  const isMobile = useMobileWidth();
  const [showContent, setShowContent] = useState(true);

  return (
    <>
      {showContent && (
        <BannerSection>
          <LeftColumn bgImage={bgImage} />

          <RightColumn>
            {isMobile && (
              <CloseIconWrapper
                onClick={e => {
                  e.preventDefault();
                  setShowContent(false);
                }}
              >
                <Icon
                  size={30}
                  name="close"
                  color={theme.color.white}
                  indentLess
                />
              </CloseIconWrapper>
            )}

            <Title>{t('table-teaser-text')}</Title>
            <Button
              title={t('book-now')}
              backgroundColor={sluggedEvent?.design?.themeColor}
              hoverBackgroundColor={theme.color.mobilityGrey}
              textColor={theme.color.white}
              borderRadius={theme.borderRadius.radius10}
              padding="0.8rem 4.9rem"
              width={isMobile ? '100%' : 'max-content'}
              onClick={() => {
                window.location.href = `${window.location.origin}/events/${sluggedEvent?.slug}${t('book-now-url')}`;
              }}
            />
          </RightColumn>
        </BannerSection>
      )}
    </>
  );
};
